export default __webpack_public_path__ + "static/media/CCIB_LOGO_W.ec71852b.png";